import React, { FunctionComponent } from 'react'

/* eslint-disable react/self-closing-comp */
const FooterLogo: FunctionComponent<{ color?: string }> = ({ color }) => (
  <svg
    width="123px"
    height="36px"
    viewBox="0 0 123 36"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlinkHref="http://www.w3.org/1999/xlink"
  >
    <title>Logo</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <path
        d="M7.21604089,5.16857143 L9.41340672,5.58 C8.99292314,7.74 7.16178494,9 4.82877924,9 C2.1295459,9 0,7.03285714 0,4.5 C0,1.98 2.1295459,0 4.82877924,0 C7.06683704,0 8.96579516,1.26 9.39984274,3.30428571 L7.2024769,3.79285714 C6.91763318,2.54571429 5.99528209,1.94142857 4.82877924,1.94142857 C3.39099666,1.94142857 2.23805779,3.03428571 2.23805779,4.5 C2.23805779,5.96571429 3.39099666,7.07142857 4.82877924,7.07142857 C5.9817181,7.07142857 6.9040692,6.45428571 7.21604089,5.16857143 Z M21.0377433,0.192857143 L24.8356595,8.80714286 L22.4483979,8.80714286 L21.8108905,7.23857143 L17.9858463,7.23857143 L17.3483389,8.80714286 L14.9475133,8.80714286 L18.7454295,0.192857143 L21.0377433,0.192857143 Z M18.7454295,5.41285714 L21.0513073,5.41285714 L19.8983684,2.58428571 L18.7454295,5.41285714 Z M34.3847061,0 C36.3650482,0 37.8028307,0.925714286 38.1419304,2.49428571 L35.9445646,2.91857143 C35.7817967,2.10857143 35.0764694,1.71 34.3575781,1.71 C33.6115589,1.71 33.1368193,2.09571429 33.1368193,2.58428571 C33.1368193,2.93142857 33.2995872,3.18857143 33.8692746,3.30428571 L35.7546688,3.70285714 C37.3280912,4.03714286 38.2504423,4.84714286 38.2504423,6.21 C38.2504423,8.04857143 36.527816,9 34.506782,9 C32.45862,9 30.7766857,8.07428571 30.5325339,6.39 L32.8384116,5.96571429 C33.0689994,6.85285714 33.7200708,7.23857143 34.6288579,7.23857143 C35.469825,7.23857143 35.9716925,6.87857143 35.9716925,6.35142857 C35.9716925,5.96571429 35.7817967,5.72142857 35.1307254,5.59285714 L33.2317672,5.20714286 C31.9296245,4.92428571 30.7902497,4.28142857 30.7902497,2.71285714 C30.7902497,1.04142857 32.2551602,0 34.3847061,0 Z M51.0684097,0.192857143 L53.2929035,0.192857143 L53.2929035,8.80714286 L51.0684097,8.80714286 L51.0684097,5.4 L47.2433654,5.4 L47.2433654,8.80714286 L45.0053076,8.80714286 L45.0053076,0.192857143 L47.2433654,0.192857143 L47.2433654,3.54857143 L51.0684097,3.54857143 L51.0684097,0.192857143 Z M69,0.192857143 L65.4055435,6.10714286 L65.4055435,8.80714286 L63.1267938,8.80714286 L63.1267938,6.13285714 L59.6137213,0.192857143 L62.0552388,0.192857143 L64.2932966,3.97285714 L66.5042265,0.192857143 L69,0.192857143 Z"
        id="path-1"
      ></path>
      <path
        d="M18,0 L18,8.94589178 L8.928,8.94589178 L8.928,17.9639279 L18,17.9639279 L18,26.9819639 L13.464,26.9819639 C6.028032,26.9819639 0,20.9418517 0,13.490982 C0,6.04011222 6.028032,0 13.464,0 L18,0 Z M18,8.94589178 L22.5,8.94589178 C29.95584,8.94589178 36,15.0021643 36,22.4729459 C36,29.9437275 29.95584,36 22.5,36 L18,36 L18,26.9819639 L27.072,26.9819639 L27.072,17.9639279 L18,17.9639279 L18,8.94589178 Z"
        id="path-3"
      ></path>
    </defs>
    <g
      id="UI_Cashy"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="01_Homepage" transform="translate(-28.000000, -50.000000)">
        <g id="Menu" transform="translate(0.000000, 35.000000)">
          <g id="Logo" transform="translate(28.000000, 15.000000)">
            <g id="naming" transform="translate(54.000000, 14.000000)">
              <mask id="mask-2" fill="white">
                <use xlinkHref="#path-1"></use>
              </mask>
              <use id="Clip-2" fill={color} xlinkHref="#path-1"></use>
            </g>
            <g id="monogram">
              <mask id="mask-4" fill="white">
                <use xlinkHref="#path-3"></use>
              </mask>
              <use id="Clip-5" fill={color} xlinkHref="#path-3"></use>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
/* eslint-enable react/self-closing-comp */

export default FooterLogo
